import { ApiResponse } from 'apisauce';
import { userApi } from '@/shared/services/apis/user-api.service';
import { FcmDataModel, DeleteFcmDataModel } from '@/shared/models/fcm-data.model';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import errorHelper from '@/shared/services/helpers/error-helper/error-helper.service';

/**
 * Update client FCM token on server
 * @param fcmData FCM token data
 * @param containerName UI container name for error tracking
 * @returns Promise<boolean | ErrorInfo>
 */
export function updateClientFcmToken(
  fcmData: FcmDataModel,
  containerName: string
): Promise<boolean | ErrorInfo> {
  return userApi
    .updateClientFcmToken(fcmData)
    .then((response: ApiResponse<{}, ErrorInfo>) => {
      if (response.ok) {
        console.log('FCM token registered successfully');
        return true;
      } else {
        const error: ErrorInfo = errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          containerName,
          'updateClientFcmToken'
        );
        return error;
      }
    })
    .catch((error) => {
      console.error('Error updating FCM token:', error);
      const errorInfo: ErrorInfo = errorHelper(
        0,
        error.message || 'Network error',
        containerName,
        'updateClientFcmToken'
      );
      return errorInfo;
    });
}

/**
 * Delete client FCM token from server
 * @param fcmData FCM token data to delete
 * @param containerName UI container name for error tracking
 * @returns Promise<boolean | ErrorInfo>
 */
export function deleteClientFcmToken(
  fcmData: DeleteFcmDataModel,
  containerName: string
): Promise<boolean | ErrorInfo> {
  return userApi
    .deleteClientFcmToken(fcmData)
    .then((response: ApiResponse<{}, ErrorInfo>) => {
      if (response.ok) {
        console.log('FCM token unregistered successfully');
        return true;
      } else {
        const error: ErrorInfo = errorHelper(
          Number(response.status),
          response.data && response.data.errorCode
            ? String(response.data.errorCode || '')
            : response.problem,
          containerName,
          'deleteClientFcmToken'
        );
        return error;
      }
    })
    .catch((error) => {
      console.error('Error deleting FCM token:', error);
      const errorInfo: ErrorInfo = errorHelper(
        0,
        error.message || 'Network error',
        containerName,
        'deleteClientFcmToken'
      );
      return errorInfo;
    });
}
